<template>
  <div
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    :id="id"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-xl"
      style="max-width: 90%"
      v-if="modalAttachments.length > 0"
    >
      <div class="modal-content">
        <div class="p-2 d-flex flex-row-reverse">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            id="modal-comments"
            style="background-color: transparent; border: 0"
            @click="closeModal"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="row p-1" v-if="modalAttachments.length > 0">
          <!--:ref="mySwiper"-->
          <swiper
            :navigation="true"
            :modules="modulesmodal"
            @swiper="onSwiper"
            class="mySwiper"
          >
            <swiper-slide
              v-for="(attachment, index) in modalAttachments"
              :key="index"
            >
              <figure class="product-main-image">
                <div
                  v-if="
                    attachment.type_file == 'mp4' ||
                    attachment.type_file == 'mv4'
                  "
                >
                  <video-component
                    :options="getOptons(attachment.path)"
                  ></video-component>
                </div>
                <div
                  v-else-if="
                    attachment.type_file == 'jpg' ||
                    attachment.type_file == 'jpeg' ||
                    attachment.type_file == 'png'
                  "
                >
                  <img :src="attachment.path" class="custom-zoom" />
                </div>
                <div v-else-if="attachment.type_file == 'dcm'">
                  <router-link
                    class="btn btn-primary"
                    :to="'/casi-clinici/visualizzatore-dicom/' + attachment.id"
                    >Clicca qui per analizzare i dicom</router-link
                  >
                </div>
              </figure></swiper-slide
            >
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import VideoComponent from "@/components/VideoComponent.vue";
import "swiper/css";
import "swiper/css/navigation";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "ModalAttachmentsComponent",
  props: ["attachments", "id"],
  components: {
    Swiper,
    SwiperSlide,
    VideoComponent,
  },
  setup() {
    return {
      modulesmodal: [Navigation],
    };
  },
  data() {
    return {
      modalAttachments: [],
    };
  },
  mounted() {
    this.modalAttachments = this.attachments;
  },
  created() {},
  methods: {
    closeModal() {
      //this.modalAttachments = [];
      $("#" + this.id).modal("hide");
    },
    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
  },
};
</script>
